import React from 'react'

const StepFinal = ({formData,handleChangeInput,handleNextStep,handlePrevStep}) => {
  return (
    <div>
        <h1 className='mt-2 text-xl font-bold text-blue-500'>Schritt D: Übersicht</h1>

    </div>
  )
}

export default StepFinal